<template>
  <div class="addAddress absolute">
    <div class="list">
      <div class="item acea-row row-between-wrapper">
        <div class="name">数量</div>
        <input type="text" placeholder="请输入数量" v-model="num" required />
      </div>
      <div class="item acea-row row-between-wrapper">
        <div class="name">姓名</div>
        <input
          type="text"
          placeholder="请输入姓名"
          v-model="real_name"
          required
        />
      </div>
      <div class="item acea-row row-between-wrapper">
        <div class="name">联系电话</div>
        <input
          type="text"
          placeholder="请输入联系电话"
          v-model="phone"
          required
        />
      </div>
      <div class="item acea-row row-between-wrapper">
        <div class="name">所在地区</div>
        <div
          class="picker acea-row row-between-wrapper select-value form-control"
        >
          <div class="address">
            <div slot="right" @click.stop="show2 = true">
              {{ model2 || "请选择收货地址" }}
            </div>
            <CitySelect
              ref="cityselect"
              v-model="show2"
              :callback="result2"
              :items="district"
              :ready="ready"
              provance=""
              city=""
              area=""
            ></CitySelect>
          </div>
          <div class="iconfont icon-dizhi font-color-red"></div>
        </div>
      </div>
      <div class="item acea-row row-between-wrapper">
        <div class="name">详细地址</div>
        <input
          type="text"
          placeholder="请填写具体地址"
          v-model="detail"
          required
        />
      </div>
    </div>
    <div></div>
    <div class="keepBnt bg-color-red" @click="submit">立即领取</div>
    <div class="consumpt">
      <div class="title acea-row row-center-wrapper">
        <span class="iconfont icon-zhuangshixian"></span>
        <span class="name">领取记录</span>
        <span class="iconfont icon-zhuangshixian lefticon"></span>
      </div>
      <div class="consumpt_list">
        <div
          class="consumpt_list_item"
          v-for="(item, index) in receiveList"
          :key="index"
        >
          <div class="consumpt_list_title">
            <p class="">{{ item.add_time }}</p>
            <p class="consumpt_order">{{ item.fail_msg }}</p>
          </div>
          <div class="consumpt_list_name">
            <p class="">收货人：{{ item.name }}</p>
            <div class="consumpt_list_name_zhuangtai">
              <p class="" style="color: #A5A5A5;" v-if="item.status == 0">
                未审核
              </p>
              <p class="" style="color: #09BB07;" v-if="item.status == 1">
                已审核
              </p>
              <p class="" style="color: #FF4C3C;" v-if="item.status == -1">
                未通过
              </p>
            </div>
          </div>
          <!-- v-for="(item,index) in recordList" -->
          <p class="">数量：{{ item.money }}</p>
          <!-- <p class="">价格：{{item.price}}</p> -->
          <p class="">收货人手机号：{{ item.phone }}</p>
          <p class="">地址：{{ item.address }}{{ item.xiangqing }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
.acea-row.row-center-wrapper {
  margin-top: 0.5rem;
}
.title .iconfont {
  font-size: 1.7rem;
  color: #454545;
  height: 0.5rem;
  line-height: 0.5rem;
}
.lefticon {
  transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -o-transform: rotate(180deg);
}
.consumpt_list {
  border-top: 1px dashed #eeeeee;
}
.consumpt_list_item {
  padding: 10px 12px !important;
  display: block;
  border-bottom: 1px solid #ddd;
}
.consumpt_list_title {
  display: flex;
  align-items: center;
  line-height: 30px;
  border-bottom: 1px solid #ddd;
}
.consumpt_list_name {
  display: flex;
  align-items: center;
  line-height: 25px;
}
.consumpt_list_name_zhuangtai {
  color: #ff4c48;
  margin-left: auto;
}
.consumpt_list_title:first-child p {
  text-align: left;
}
.consumpt_order {
  margin-left: auto !important;
}
</style>
<script type="text/babel">
import { CitySelect } from "vue-ydui/dist/lib.rem/cityselect";
import { getAddress, postAddress, getExtract, getReceive } from "@api/user";
import { getCity } from "@api/public";

import { openAddress } from "@libs/wechat";
import { isWeixin } from "@utils";

export default {
  components: {
    CitySelect
  },
  data() {
    return {
      show2: false,
      model2: "",
      district: [],
      id: 0,
      userAddress: { is_default: 0 },
      address: {},
      isWechat: isWeixin(),
      ready: false,
      num: "", //数量
      real_name: "", //姓名
      phone: "", //电话
      detail: "", //详情地址
      details: [],
      receiveList: "" //领走记录
    };
  },
  mounted: function() {
    let id = this.$route.params.id;
    this.id = id;
    document.title = !id ? "添加地址" : "修改地址";
    // this.getUserAddress();
    this.getCityList();
    this.getReceiveList();
  },
  filters: {
    formatDate: function(value) {
      var date = new Date(value * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + "-";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var D = date.getDate() + " ";
      var h = date.getHours() + ":";
      var m = date.getMinutes() + ":";
      var s = date.getSeconds();
      return Y + M + D + h + m + s;
    }
  },
  methods: {
    getReceiveList: function() {
      getReceive().then(res => {
        console.log(res.data);
        this.receiveList = res.data;
      });
    },

    getCityList: function() {
      let that = this;
      getCity()
        .then(res => {
          that.district = res.data;
          that.ready = true;
        })
        .catch(err => {
          this.$dialog.error(err.response.data.msg);
        });
    },
    getUserAddress: function() {
      if (!this.id) return false;
      let that = this;
      getAddress(that.id)
        .then(res => {
          that.userAddress = res.data;
          that.model2 =
            res.data.province + " " + res.data.city + " " + res.data.district;
          that.address.province = res.data.province;
          that.address.city = res.data.city;
          that.address.city_id = res.data.city_id;
        })
        .catch(err => {
          this.$dialog.error(err.response.data.msg);
        });
    },
    getAddress() {
      openAddress().then(userInfo => {
        this.$dialog.loading.open();
        postAddress({
          id: this.id,
          real_name: userInfo.userName,
          phone: userInfo.telNumber,
          address: {
            province: userInfo.provinceName,
            city: userInfo.cityName,
            district: userInfo.countryName
          },
          detail: userInfo.detailInfo,
          is_default: 1,
          post_code: userInfo.postalCode,
          type: 1
        })
          .then(() => {
            this.$dialog.loading.close();
            this.$dialog.toast({ mes: "添加成功" });
            this.$router.go(-1);
          })
          .catch(err => {
            this.$dialog.loading.close();
            this.$dialog.error(err.msg || "添加失败");
          });
      });
    },
    async submit() {
      if (this.num == "" || this.num == undefined) {
        this.$dialog.toast({
          mes: "请输入数量"
        });
      } else if (this.real_name == "" || this.real_name == undefined) {
        this.$dialog.toast({
          mes: "请输入姓名"
        });
      } else if (this.phone == "" || this.phone == undefined) {
        this.$dialog.toast({
          mes: "请输入手机号"
        });
      } else if (this.model2 == "" || this.model2 == undefined) {
        this.$dialog.toast({
          mes: "请输入收货地址"
        });
      } else if (this.detail == "" || this.detail == undefined) {
        this.$dialog.toast({
          mes: "请输入详情收货地址"
        });
      } else {
        let that = this,
          data = {
            name: that.real_name,
            money: that.num,
            phone: that.phone,
            address: that.model2,
            xiangqing: that.detail
          };
        console.log(data);
        getExtract(data)
          .then(res => {
            this.$dialog.toast({
              mes: res.msg
            });
            setTimeout(function() {
              this.getReceiveList();
            }, 2000);
          })
          .catch(res => {
            this.$dialog.toast({
              mes: res.msg
            });
            setTimeout(function() {
              this.getReceiveList();
            }, 2000);
          });
      }
    },
    ChangeIsDefault: function() {
      this.userAddress.is_default = !this.userAddress.is_default;
    },
    result2(ret) {
      this.model2 = ret.itemName1 + " " + ret.itemName2 + " " + ret.itemName3;
      this.address.province = ret.itemName1;
      this.address.city = ret.itemName2;
      this.address.city_id = ret.itemValue2;
      this.address.district = ret.itemName3;
    }
  }
};
</script>
